import {filter, forEach, sample, without, maxBy} from 'lodash'


export default {
    appendPlayer(state, player) {
        state.gameState.settings.players.push(player);
    },
    removePlayer(state, index) {
        state.gameState.settings.players.splice(index, 1);
    },

    updateWordChunck(state, chunck) {
        state.gameState.currentWordChunks= chunck

    },

    setTimer(state, time) {
        state.gameState.settings.time=time
    },
    setCountForWin(state, countForWin) {
        state.gameState.settings.countForWin=countForWin
    },

    updatePlayerImage(state, indexArr) {
        state.gameState.settings.players[indexArr[1]].image = indexArr[0];
    },
    updatePlayerTitle(state, indexArr) {
        state.gameState.settings.players[indexArr[1]].title = indexArr[0];
    },
    appendUsedWord(state, word) {
        state.gameState.usedWord = state.gameState.usedWord.concat(word);
    },
    appendResolvedWord(state, resolvedWord) {
        state.gameState.settings.players[state.gameState.currentPlayer].resolved.push(resolvedWord)
        state.gameState.settings.players[state.gameState.currentPlayer].score = state.gameState.settings.players[state.gameState.currentPlayer].score + resolvedWord.score
    },
    appendUnresolvedWord(state, unresolvedWord) {
        state.gameState.settings.players[state.gameState.currentPlayer].unresolved.push(unresolvedWord)
    },
    nextPlayer(state) {
        if (state.gameState.currentPlayer + 1 < state.gameState.settings.players.length) {
            state.gameState.currentPlayer++
        } else {
            state.gameState.currentPlayer = 0
        }
    },
    wordSet(state) {
        let w = [[], [], []];
        let cleanWord = [[], [], []];
        let wordSet = [];
        forEach(state.gameState.currentWordChunks, function (value) {
            w[0].push(...filter(state.chunks, ['title', value])[0].wordSets[0].words);
            w[1].push(...filter(state.chunks, ['title', value])[0].wordSets[1].words);
            w[2].push(...filter(state.chunks, ['title', value])[0].wordSets[2].words);
        });
        forEach(w, function (value, key) {
            cleanWord[key].push(...without(value, ...state.gameState.usedWord))
        });
        forEach(cleanWord, function (value) {
            wordSet.push(sample(value))
        });
        state.gameState.cleanWordsSet = cleanWord;
        state.gameState.currentWordsSet = wordSet;
    },
    detectWinner(state) {
        forEach(state.gameState.settings.players, function (value) {
            if (value.score >= state.gameState.settings.countForWin) {
                state.gameState.winner = value
            } else {
                if (state.gameState.cleanWordsSet[0].length === 1) {
                    state.gameState.winner = maxBy(state.gameState.settings.players, 'score')
                }
            }
        })
    },
    logData(state) {
        state.currentGameState = state.gameState
        localStorage.setItem('currentGame', JSON.stringify(state.gameState));
    },
    loadData(state) {
        if (localStorage.getItem('currentGame')) {
            state.currentGameState = JSON.parse(localStorage.getItem('currentGame'));
            state.gameState = state.currentGameState
        }

    },
    cleanData(state) {
        localStorage.removeItem('currentGame');
        state.gameState = state.cleanGameState
    },
}
